module.exports = __webpack_public_path__ + "1e6f3cd1404ac760b16f557ab0a388d8.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2026-02-04/whats-new.html
// module id = 2260
// module chunks = 0